import { Box, Tooltip } from '@chakra-ui/react';
import { motion } from 'framer-motion';

// Sparkle icon - four-pointed star
const SparkleIcon = ({ size = 24 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z"
      fill="white"
    />
  </svg>
);

interface AIAssistantFABProps {
  onClick: () => void;
  isVisible: boolean;
  /** Fixed distance from viewport edges (px). Defaults match the classic dashboard FAB. */
  fixedBottomPx?: number;
  fixedRightPx?: number;
  tooltipLabel?: string;
  'aria-label'?: string;
}

export function AIAssistantFAB({
  onClick,
  isVisible,
  fixedBottomPx = 24,
  fixedRightPx = 24,
  tooltipLabel = 'AI Assistant',
  'aria-label': ariaLabel = 'Open AI Assistant',
}: AIAssistantFABProps) {
  if (!isVisible) {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      transition={{ duration: 0.2 }}
      style={{
        position: 'fixed',
        bottom: `${fixedBottomPx}px`,
        right: `${fixedRightPx}px`,
        zIndex: 1000,
      }}
    >
      <Tooltip label={tooltipLabel} placement="left" hasArrow>
        <Box
          as="button"
          aria-label={ariaLabel}
          onClick={onClick}
          width="48px"
          height="48px"
          borderRadius="full"
          bgGradient="linear(to-br, #2674D1, #5AD0D0, #9ADF7A)"
          boxShadow="0 2px 8px rgba(0, 0, 0, 0.15)"
          display="flex"
          alignItems="center"
          justifyContent="center"
          position="relative"
          cursor="pointer"
          transition="all 0.2s"
          _hover={{
            transform: 'scale(1.05)',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
          }}
          _active={{
            transform: 'scale(0.95)',
          }}
        >
          {/* Larger sparkle - bottom-left area */}
          <Box position="absolute" left="8px" top="18px">
            <SparkleIcon size={26} />
          </Box>
          {/* Smaller sparkle - top-right area */}
          <Box position="absolute" right="8px" top="10px">
            <SparkleIcon size={19} />
          </Box>
        </Box>
      </Tooltip>
    </motion.div>
  );
}
